import type {
  EvalExtractionType,
  ExtractionExpectedOutput,
} from '@artem-lex/common-server/evals/standardExtraction'

export const EXTRACTION_TYPE_LABELS: Record<EvalExtractionType, string> = {
  SCOPE: 'Scope',
  HAZARDS: 'Hazards',
  RISK_REDUCTION_MEASURES: 'Risk reduction measures',
  INFORMATION_FOR_USE: 'Information for use',
}

const MANUAL_GOLD_ITEM_ID = /^item-(\d+)$/

export function nextManualGoldItemId(existingIds: readonly string[]): string {
  let next = 1
  for (const id of existingIds) {
    const match = MANUAL_GOLD_ITEM_ID.exec(id)
    if (match == null) {
      continue
    }
    const value = Number(match[1])
    if (value >= next) {
      next = value + 1
    }
  }
  return `item-${next}`
}

export function goldItemCount(
  output: ExtractionExpectedOutput | undefined
): number {
  if (output == null) {
    return 0
  }
  if (output.items != null) {
    return output.items.length
  }
  return (output.scope?.expectedScope?.trim() ?? '').length > 0 ? 1 : 0
}

export function canSaveAsExtractionGoldDraft(input: {
  isArtemAdmin: boolean
  evalOrganizationId?: string | null
  standardOrganizationId: string
}): boolean {
  if (!input.isArtemAdmin) {
    return false
  }
  const evalOrganizationId = input.evalOrganizationId?.trim() ?? ''
  return (
    evalOrganizationId.length > 0 &&
    evalOrganizationId === input.standardOrganizationId
  )
}

export function snapshotItemHint(snapshot: unknown): string {
  if (snapshot == null || typeof snapshot !== 'object') {
    return 'Empty snapshot'
  }
  const record = snapshot as Record<string, unknown>
  if (typeof record.scope === 'string') {
    return record.scope.trim().length > 0
      ? 'Scope text captured'
      : 'Empty scope'
  }
  if (Array.isArray(record.hazards)) {
    return `${record.hazards.length} extracted hazards`
  }
  if (Array.isArray(record.measures)) {
    return `${record.measures.length} extracted measures`
  }
  if (Array.isArray(record.clauses)) {
    return `${record.clauses.length} extracted clauses`
  }
  return 'Snapshot captured'
}
